import angular from 'angular'

import { isText } from '../utils/bits'
import { has, assign, constant, isUndefined } from 'lodash-es'

import iconsData from './ggs-icons.data'

angular
  .module('ggs.icons')
  .directive('ggsIcon', IconDirective)

const BASE_COLOR = 'ggs-icon__base-color'
const BASE_BACKGROUND = 'ggs-icon__base-background'

const CIRCLE = 'ggs-icon__circle'
const STROKE = 'ggs-icon__stroke'

const FALSE = assign(constant(false), { oneTime: true })

const UNKNOWN = 'unknown'

function IconDirective($parse) {
  return {
    restrict: 'E',
    link($scope, $elm, $attr) {
      let classes = ''

      const expName = $parse($attr.ggsIconName)
      const expStrokes = isText($attr.ggsIconStrokes) ? $parse($attr.ggsIconStrokes) : FALSE
      const expCircles = isText($attr.ggsIconCircles) ? $parse($attr.ggsIconCircles) : expStrokes
      const expInverts = isText($attr.ggsIconInverts) ? $parse($attr.ggsIconInverts) : expCircles

      const initName = expName($scope)
      const initCircles = expCircles($scope)
      const initStrokes = expStrokes($scope)
      const initInverts = expInverts($scope)

      const applyOnce = true
        && expName.oneTime
        && expCircles.oneTime
        && expStrokes.oneTime
        && expInverts.oneTime
        && !isUndefined(initName)
        && !isUndefined(initCircles)
        && !isUndefined(initStrokes)
        && !isUndefined(initInverts)

      if (applyOnce) {
        applyIcon([initName, initCircles, initStrokes, initInverts])
      } else {
        $scope.$watchGroup([expName, expCircles, expStrokes, expInverts], applyIcon)
      }

      function addClass(newClass) {
        classes += (' ' + newClass)
        $elm.addClass(newClass)
      }

      function clearClasses() {
        $elm.removeClass(classes)
        classes = ''
      }

      function applyIcon([name, circles, strokes, inverts]) {
        if (!isText(name)) {
          name = UNKNOWN
        }

        let iconData = null
        for (const local of iconsData) {
          if (name === local.name) {
            iconData = local
            break
          }
        }

        if (!iconData) {
          return
        }

        clearClasses()

        addClass(iconData.icon)

        inverts
          ? addClass(BASE_COLOR)
          : addClass(iconData.color)

        if (circles) {
          addClass(CIRCLE)

          inverts
            ? addClass(iconData.background)
            : addClass(BASE_BACKGROUND)

          if (has(iconData, 'circle')) {
            addClass(iconData.circle)
          }

          if (strokes) {
            addClass(STROKE)

            if (has(iconData, 'stroke')) {
              addClass(iconData.stroke)
            }
          }
        }
      }
    }
  }
}
